<script>
// Shared Active/Inactive toggle for the Real Estate module — used on the
// project card, the projects table and the project detail header. It's a
// pure presentational control: the parent owns the API call and the
// `value` it renders, this component only emits `toggle` on click.
export default {
  name: 'ActiveSwitch',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
      validator: value => ['sm', 'md'].includes(value),
    },
  },
  computed: {
    trackSizeClass() {
      return this.size === 'sm' ? 'w-8 h-4' : 'w-9 h-5';
    },
    thumbSizeClass() {
      return this.size === 'sm' ? 'w-3 h-3' : 'w-4 h-4';
    },
    thumbTranslateClass() {
      if (!this.value) return '';
      return this.size === 'sm' ? 'translate-x-3.5' : 'translate-x-4';
    },
    label() {
      return this.value
        ? this.$t('REAL_ESTATE.DETAIL.ACTIVE_LABEL')
        : this.$t('REAL_ESTATE.DETAIL.INACTIVE_LABEL');
    },
    tooltip() {
      return this.value
        ? this.$t('REAL_ESTATE.CARD.ACTIVE_TOOLTIP')
        : this.$t('REAL_ESTATE.CARD.INACTIVE_TOOLTIP');
    },
  },
  methods: {
    handleClick() {
      if (this.disabled) return;
      this.$emit('toggle');
    },
  },
};
</script>

<template>
  <button
    type="button"
    role="switch"
    :aria-checked="String(value)"
    :title="tooltip"
    :disabled="disabled"
    class="inline-flex items-center gap-2 disabled:opacity-60 focus:outline-none focus-visible:ring-2 focus-visible:ring-woot-500 rounded-full"
    @click.stop.prevent="handleClick"
  >
    <span
      class="relative inline-flex items-center rounded-full transition-colors"
      :class="[
        trackSizeClass,
        value ? 'bg-woot-500' : 'bg-slate-300 dark:bg-slate-600',
      ]"
    >
      <span
        class="inline-block m-0.5 rounded-full bg-white shadow transform transition-colors"
        :class="[thumbSizeClass, thumbTranslateClass]"
      />
    </span>
    <span
      v-if="showLabel"
      class="text-xs font-medium text-slate-600 dark:text-slate-300"
    >
      {{ label }}
    </span>
  </button>
</template>
